"use strict";

var LoggerInstance = require("js-logger").get("PledgeStatementHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var PledgeStatementApi = require("../api/PledgeStatementApi");

var Spinner = require("../client/Spinner");

var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var PledgeStatementHelper = {
	submitPledgeStatementForm: function (event) {
		event = this._getEventOrReturn(event, "Submit Pledge Statment Form called successfully.");
		if (!event) {
			return;
		}

		var $pledgeStatementFormComponent = $(event.target).closest('[data-component="pledgeStatementForm"]');

		var components = [
			$pledgeStatementFormComponent
		];

		Spinner.showSpinner();
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				Spinner.removeSpinner();
				return;
			}

			var pledgeStatementData = ActionsHelper.serializeForm($pledgeStatementFormComponent.find("form"));

			PledgeStatementApi.submitPledgeStatement(pledgeStatementData).done(() => {
				window.location = "/shoppingcart";
			}).fail((response) => {
				var defaultErrorMessage = window.AccountStore.getWizardValue(
					WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY,
					WizardConstants.PLEDGE_STATEMENT_ENTRY_FIELDS.INVALID_ACCOUNT_OR_PLEDGE_STATEMENT_MESSAGE
				);

				var responseObject = response && response.responseJSON || {};
				var errorMessage = responseObject.messageGuaranteedConstituentSafe && responseObject.message || defaultErrorMessage;

				BootstrapPrompt.alert(errorMessage);
				Spinner.removeSpinner();
			});
		});
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		var isDesignMode = window.AccountStore && window.AccountStore.get("isDesignMode");
		return ActionsHelper.getEventOrReturn(event, isDesignMode, isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	},

	confirmAbandonPledgeStatementSession: function (isInPledgeStatementSession, pledgeStatementEntryWizard) {
		var deferred = $.Deferred();

		if (isInPledgeStatementSession) {
			pledgeStatementEntryWizard = pledgeStatementEntryWizard || {};

			BootstrapPrompt.confirm({
				btnCancelLabel: window.BUTTON_LABELS.NO,
				btnOKLabel: window.BUTTON_LABELS.YES,
				message: pledgeStatementEntryWizard[WizardConstants.PLEDGE_STATEMENT_ENTRY_FIELDS.SESSION_ABANDONMENT_WARNING_MESSAGE]
			}, (shouldAbandonPledgeStatementSession) => {
				if (shouldAbandonPledgeStatementSession) {
					deferred.resolve();
				} else {
					deferred.reject();
				}
			});
		} else {
			deferred.resolve();
		}

		return deferred;
	}
};

module.exports = PledgeStatementHelper;


// WEBPACK FOOTER //
// ./Javascript/accountComponents/PledgeStatementHelper.jsx